    <template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">AP Invoice (Customer Bill) 
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="print()">Print Bill</b-button>
          <!-- <b-button variant="primary mr-1" @click="exportcsv()">CSV e-Faktur</b-button> -->
          <button class="btn btn-primary mr-1" @click="close()" > <i class="fa fa-close"></i> Close</button>
        </div>
      </div>
      <b-input-group>
          <b-input-group-prepend><span class="mt-1 mr-2">Print the following invoice number : </span></b-input-group-prepend>
          <b-input-group-append>
          <b-btn text="Button" @click="lkuApShow=true" size="sm" >
              <i class="fa plus-square"></i> Add Invoice
          </b-btn>
          </b-input-group-append>
      </b-input-group>

      <div class="report-wraper">
                <b-row >
                <div class="col-sm-6 col-lg-3" v-for="(inv,idx) in invoices" :key="inv.apinvkey">
                  <b-card :no-body="true">
                    <div class="p-3 clearfix">
                      <div class="h5 text-info mb-0 mt-2">{{inv.nomor}} <b-link @click="delInvoice(idx)" class="ml-2">  <i class="fa fa-trash"></i></b-link></div>
                        <small class="text-muted">{{inv.vendorinfo}}</small>
                    </div>
                  </b-card>
                </div>
                </b-row>

      </div>
    </b-card>
        <b-modal v-model="lkuApShow" size="lg" :hide-footer="true" title="List of AP Invoice"  :centered="true">
            <lku-ap @click="onSelectlkuAp" :formdata="lkuApData" ></lku-ap>
        </b-modal>   
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4" ></loading>       
    <b-modal v-model="showReport" size="xl" scrollable title="Preview as PDF" ok-only>
        <iframe :src="reportUrl" frameborder="0"></iframe>
    </b-modal>

  </div>
</template>

<style lang="scss">
  .invoicelist{
    ul {
        -webkit-column-count: 4;
        -moz-column-count: 4;
        column-count: 4;
    }
  }
</style>

<script>
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import toastr from "mini-toastr";
import lkuAp from "../lookup/lkuApLazzy";
import apinv from "../../apis/apinv";

toastr.init();

export default {
  components: { Loading, lkuAp },
  data() {
    return {
      invoices:[],
      lkuApShow:false,
      isLoading:false,
      showReport:false,
      reportUrl: null,
      lkuApData:{}
    };
  },
  computed: {
    tblFields(){
      const fields=[
          {
            key: "nomor",
            thStyle: "width:50px",
            label: "No.",
          },
          {
            key: "ostStatusname",
            label: "Outstand Status Name",
            sortable: true
          },
          {
            key: "action",
            label: "Action",
            thStyle: "width:60px",
            thClass: "text-center",
          }          
        ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    },
  },
  methods: {
    onSelectlkuAp(invLookup) {
      const ada =this.invoices.find(i => i.apinvkey == invLookup.selected.apinvkey);
      if (ada){
          toastr.error(`Nomor Invoice "${invLookup.selected.invoice}" sudah ada dalam List`)
      } else {
        this.invoices.push({
            apinvkey:invLookup.selected.apinvkey,
            nomor:invLookup.selected.nomor,
            vendorinfo: invLookup.selected.vendorinfo });
      }
      // this.model.custcode=invLookup.selected.custcode;
      // this.model.CustName=invLookup.selected.CustName;
      this.lkuApShow=false;
      this.lkuApData=invLookup;
      // for (var key in invLookup) {
      //     this.lkuApData[key] = invLookup[key];
      // }
    },
    delInvoice : function (index) {
        if (index > -1) {
            this.invoices.splice(index, 1);
        }
    },
    exportcsv: async function() {
      if (this.invoices.length>0) {
          this.isLoading=true;
          try {
              let arrInv = this.invoices.reduce((newArr, item) => {
                  newArr.push(item.apinvkey);
                  return newArr;
              }, []);
            toastr.info('Export to CSV ');
            const response = await apinv.printbillcsv(arrInv);
            this.isLoading=false;    
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please select a row that want to be Export!');
        }
    },    
    print: async function()
    {
      if (this.invoices.length>0) {
          this.isLoading=true;
          try {
              let arrInv = this.invoices.reduce((newArr, item) => {
                  newArr.push(item.apinvkey);
                  return newArr;
              }, []);

              this.isLoading=false;
                this.showReport=true;
              this.reportUrl= await apinv.printbills(arrInv);
              if (this.$isMobile()){
                  this.showReport=false;              
                  window.location.href= `https://docs.google.com/viewerng/viewer?url=${this.reportUrl}`;
              }
          } catch (error) {
              this.isLoading=false;
              if (error.message) {
                  toastr.error(error.message);
              } else {
                  toastr.error(JSON.stringify(error));
              }
          }
        } else {
            toastr.warn('Please add invoice to be Printed!');
        }
    },
    close(){
      router.push("home");
    },    
  }
};
</script>
